import { useEffect, useState } from 'react'
import { Outlet, useMatch } from 'react-router'
import { AppNav } from './AppNav'
import { AppSidebar } from './AppSidebar'
import { AppLogoRail } from './AppLogoRail'
import { AppFooter } from './AppFooter'
import { writeShell } from './shell'
import styles from './AppLayout.module.css'

/**
 * Product chrome: fixed nav, docked collapsible sidebar, fixed footer.
 *
 * The public marketing surface used to run through here too, switched by a
 * `pathname === '/'` boolean that drove four separate behaviours. It now has
 * its own PublicLayout, so this is purely the signed-in shell again.
 */
export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(false)
  // The org and admin remotes draw their own chrome on these routes, so the
  // shell's is hidden from the first paint rather than flashing until the
  // remote loads. See @carouselgg/auth/remote-chrome.
  const remoteChrome = useMatch('/org/:slug/*') !== null

  // Record that this tab is browsing inside the app, so a discovery page the
  // sidebar links to keeps this shell for a signed-out visitor too.
  useEffect(() => {
    writeShell('app')
  }, [])

  return (
    <>
      <div className="bgGlow" />
      <div className={styles.layout} data-shell="layout" data-chrome={remoteChrome ? 'remote' : 'app'}>
        {/* The collapse toggle lives in the app bar, not on the sidebar's edge.
            It used to be a fixed-position gradient circle at `top: 140px` with
            a hardcoded `left` of 38 or 222 that duplicated the sidebar width —
            so it sat at a height aligned to nothing and jumped 184px sideways
            the moment you clicked it. In the bar it never moves. */}
        <AppNav
          onMenuToggle={() => setSidebarOpen(prev => !prev)}
          collapsed={collapsed}
          onCollapseToggle={() => setCollapsed(prev => !prev)}
        />
        {/* Your teams and orgs, beside the open nav. Collapsed, they fold into
            the nav's own rail; on a phone they move into the drawer. */}
        {!collapsed && <AppLogoRail className={styles.logoRail} />}
        <AppSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          style={{ top: 64 }}
          collapsed={collapsed}
          className={collapsed ? undefined : styles.besideRail}
        />
        <main className={`${styles.content} ${collapsed ? styles.contentCollapsed : ''}`}>
          <Outlet />
        </main>
        <AppFooter collapsed={collapsed} />
      </div>
    </>
  )
}
